import axios from 'axios';

import { GET_INVENTORY } from './types';

export const getInventory = () => async dispatch => {
    const res = await axios.get('/api/inventory/')
    dispatch({ type: GET_INVENTORY, payload: res.data });
};